module.exports = __webpack_public_path__ + "img/PRINT.e03d38fb.svg";